// extracted by mini-css-extract-plugin
export default {"remove":"SurveyValidationEditor_remove__k4Q1K","questionsReference":"SurveyValidationEditor_questionsReference__r68h-","scroll":"SurveyValidationEditor_scroll__pLRB2"};